import React from 'react'

interface IProps {
    className?: string
    onChange?: (e?: any) => void
    value?: string
    defaultValue?: string
    disabled?: boolean
}

const DateInput: React.FC<IProps> = ({className, onChange, value, defaultValue, disabled}) => {
    return (
        <div className={'mt-[5px]'}>
            <input
                defaultValue={defaultValue}
                value={value}
                onChange={onChange && onChange}
                type={'datetime-local'}
                disabled={disabled}
                className={`border-b border-line02 ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
            />
        </div>
    )
}

export default DateInput
